import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AuthRoutingModule } from "./auth-routing.module";
import { AuthComponent } from "./auth.component";
import { ReactiveFormsModule } from "@angular/forms";
import { NgZorroAntdModule } from "../../modules/nz-zorro-antd.module";
import { NgZorroIconModule } from "../../modules/nz-icon-antd.module";
import { HeaderModule } from "../../shared/header/header.module";
import { FooterModule } from "../../shared/footer/footer.module";
import { LoginModule } from "./login/login.module";
import { SignupModule } from "./signup/signup.module";
import { AccountActivationModule } from "./account-activation/account-activation.module";
import { TranslateModule } from "@ngx-translate/core";
import { ForgotPasswordModule } from "./forgot-password/forgot-password.module";
import { ResetPasswordModule } from "./reset-password/reset-password.module";
import { InvitationModule } from "./invitation/invitation.module";
import { NzPopoverModule } from "ng-zorro-antd/popover";

@NgModule({
	declarations: [AuthComponent],
	imports: [
		CommonModule,
		AuthRoutingModule,
		ReactiveFormsModule,
		NgZorroAntdModule,
		NgZorroIconModule,
		HeaderModule,
		FooterModule,
		LoginModule,
		SignupModule,
		AccountActivationModule,
		TranslateModule,
		ForgotPasswordModule,
		ResetPasswordModule,
		InvitationModule,
		NzPopoverModule,
	],
	exports: [AuthComponent],
})
export class AuthModule {}
